{
  "language-selection-dialog": {
    "buttons": {
      "close": "Fermer"
    },
    "text": {
      "title": "Sélection de la langue",
      "hint": "Sélectionner la langue d'affichage"
    }
  }
}
